// extracted by mini-css-extract-plugin
export default {"infoText":"CloseCaseInfo_infoText__eO1rH"};